import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { submitFingerprint } from '@/idv/utils';
import OnboardingMachineProvider from './components/machine-provider';
import Router from './pages/router';
import type { OnboardingProps } from './types';
const Onboarding = t0 => {
  const $ = _c(8);
  let args;
  if ($[0] !== t0) {
    ({
      ...args
    } = t0);
    $[0] = t0;
    $[1] = args;
  } else {
    args = $[1];
  }
  const {
    idvContext: t1
  } = args;
  const {
    authToken
  } = t1;
  let t2;
  let t3;
  if ($[2] !== authToken) {
    t2 = () => {
      submitFingerprint({
        authToken,
        path: "onboard_start"
      });
    };
    t3 = [authToken];
    $[2] = authToken;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Router />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== args) {
    t5 = <OnboardingMachineProvider args={args}>{t4}</OnboardingMachineProvider>;
    $[6] = args;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default Onboarding;